import { ApiType } from "@gymflow/common";
import { SessionPackSignupPaymentMethodRequestBody } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiV2 } from "../../apiV2";
import { memberQueryKeys } from "../member";
import { productQueryKeys } from "../product";
import { sales } from "./sales";

export function useMutationSessionPackSignupPaymentMethod({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: SessionPackSignupPaymentMethodRequestBody) =>
      (await api.salesApi.sessionPackSignupPaymentMethod(body)).data,
    onSuccess: (_, { userMemberId }) => {
      queryClient.invalidateQueries({
        queryKey: sales.all(),
      });
      queryClient.invalidateQueries({
        queryKey: memberQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: productQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: apiV2.staff.subscription.keys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: apiV2.staff.wallet.keys.list(userMemberId),
      });
    },
  });
}
